import React from 'react';
import ResiduosCheckboxGroup from './ResiduosCheckboxGroup';

const ResiduosGroup = ({data, handleSelectChange, handleInputText} ) => (

  <div style={{ display: 'flex', flexDirection: 'column' }}>
    {Object.keys(data).map((type,index) =>
      <div key={index}>
        <h3>{`Resíduos ${type}`}</h3>
        <div style={{ display: 'flex', justifyContent:"space-between", flexDirection: 'row' }}>
          {Object.keys(data[type]).map((item, index) =>
            <ResiduosCheckboxGroup
              name={`${type}.${item}`}
              data={data[type][item]}
              handleSelectChange={handleSelectChange}
              handleInputText={handleInputText}
              key={index}
            />
          )}
        </div>
      </div>
    )}
  </div>
);

export default ResiduosGroup;

